import React, { isValidElement } from "react";
import { Col } from "react-bootstrap";
import cx from "classnames";
import TimeAgo from "react-timeago";
import Text from "src/components/text";
import styles from "./styles.module.scss";

type CellType = "name" | "amount" | "prediction" | "owner" | "lastActivity";

interface TableCellProps {
  col: number;
  type?: CellType;
  value?: any;
  classnames?: string;
  showArrow?: boolean;
  fontSize?: string;
  predictionTrend?: "up" | "down";
}

const DefaultUserAvatar = "/images/default_user_profile_background.png";

const Profile: React.FC<{ ownerName: string }> = ({ ownerName }) => {
  if (!ownerName) return <p>-</p>;

  return (
    <div className={styles.profile}>
      <img src={DefaultUserAvatar} className={styles.avatar} />
      <div className={styles.name}>
        <Text text={ownerName} tooltip={{ placement: "auto" }} />
      </div>
    </div>
  );
};

const TableCell: React.FC<TableCellProps> = ({
  col,
  type,
  value,
  classnames,
  showArrow = false,
  predictionTrend,
  fontSize,
}) => {
  const renderContent = () => {
    switch (type) {
      case "name":
        if (isValidElement(value)) {
          return <div className={styles.dealName} style={fontSize ? { fontSize } : undefined}>{value}</div>;
        }
        return (
          <div className={styles.dealName} style={fontSize ? { fontSize } : undefined}>
            <Text text={value} tooltip={{ placement: "auto" }} />
          </div>
        );
      case "amount":
        return <p className={styles.value}>${value}</p>;
      case "prediction": {
        const isUp = predictionTrend === "up";
        return (
          <p
            className={cx(styles.prediction, {
              [styles.up]: isUp,
              [styles.down]: !isUp,
            })}
          >
            <i
              className={cx(
                isUp ? "paperflite-up-arrow" : "paperflite-dropdown",
                styles.icon,
              )}
            />
            {value}%
          </p>
        );
      }
      case "owner":
        return <Profile ownerName={value} />;
      case "lastActivity":
        return (
          <p className={styles.activityText}>
            <TimeAgo date={value} live={false} />
          </p>
        );
      default:
        return null;
    }
  };

  return (
    <Col md={col} className={cx(styles.cellContainer, classnames)}>
      <div className={cx(styles.contentContainer)}>
        {value !== null && value !== undefined ? renderContent() : <p>-</p>}
      </div>
      {showArrow && (
        <i className={cx("paperflite-right-arrow", styles.navArrow)} />
      )}
    </Col>
  );
};

export default TableCell;